import { createSchemaSelectors } from 'ngrx-normalizr';
import { CheckinExercise, checkinExerciseSchema, checkinQuestionSchema } from '../schemas/checkin.schema';

const checkinExerciseSchemaSelectors = createSchemaSelectors<CheckinExercise>(checkinExerciseSchema);
const checkinQuestionSchemaSelectors = createSchemaSelectors<CheckinExercise>(checkinQuestionSchema);

export const getCheckinExercises = checkinExerciseSchemaSelectors.getEntities;
export const getCheckinQuestions = checkinQuestionSchemaSelectors.getEntities;
